import { z } from "zod";

export const attachment = z.object({
  slot: z.string(),
  mimeType: z.string().optional(),
  url: z.string().url().optional(),
  data: z.string().optional(),
  type: z.union([
    z.enum(["image", "video", "audio"]),
    z.literal("url"), // Used when passing resolved URLs
  ]),
  durationMs: z.number().optional(),
  /** Media kind (image, video, audio) - used for video analysis */
  mediaKind: z.enum(["image", "video", "audio"]).optional(),
  /** URL for composite grid image (for video analysis) */
  compositeGridUrl: z.string().url().optional(),
  /** Source media record ID - used for voice_id caching and other lookups */
  mediaId: z.string().optional(),
  /** Source media width in pixels - used for provider dimension pre-flight checks */
  width: z.number().optional().nullable(),
  /** Source media height in pixels - used for provider dimension pre-flight checks */
  height: z.number().optional().nullable(),
});
